type Props = {};

const FeeScheduleIndex = (props: Props) => {
  return (
    <div>Fee Schedule Index</div>
  );
};

export default FeeScheduleIndex;